(function () {
  var GOAL = 2000;
  var applying = false;

  function formatMoney(amount) {
    var rounded = Math.round(amount * 100) / 100;
    if (rounded % 1 === 0) return String(rounded);
    return rounded.toFixed(2);
  }

  function messageFor(total) {
    if (total >= GOAL) return "Congratulations! You've got free shipping";
    if (total <= 0) return 'Free shipping for orders over £' + formatMoney(GOAL);
    return 'Only £' + formatMoney(GOAL - total) + ' away from free shipping';
  }

  function apply(total) {
    var next = messageFor(total);
    ['fsb_message', 'fsb_sr_status'].forEach(function (id) {
      var node = document.getElementById(id);
      if (!node || node.textContent.trim() === next) return;
      applying = true;
      node.textContent = next;
      applying = false;
    });
  }

  function refresh() {
    if (applying || !document.getElementById('fsb_message')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) { apply((cart.total_price || 0) / 100); })
      .catch(function () { apply(0); });
  }

  var observer = new MutationObserver(function () {
    if (!applying) refresh();
  });

  function watch() {
    var message = document.getElementById('fsb_message');
    if (!message) return;
    observer.observe(message, { childList: true, characterData: true, subtree: true });
    refresh();
  }

  if (document.getElementById('fsb_message')) watch();
  else {
    var wait = new MutationObserver(function () {
      if (document.getElementById('fsb_message')) {
        wait.disconnect();
        watch();
      }
    });
    wait.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('cart:updated', refresh);
})();
